import { render, staticRenderFns } from "./BaseErrorDialog.vue?vue&type=template&id=0852dc72&scoped=true&"
import script from "./BaseErrorDialog.vue?vue&type=script&lang=js&"
export * from "./BaseErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0852dc72",
  null
  
)

export default component.exports